export { ScoreLocked } from './ScoreLocked'
export type { ScoreLockedProps } from './types'
